module.exports = __webpack_public_path__ + "31f89ccf27ee6015c5c28ea7998cae77.png";